import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import {  api, WorkshopListURL } from "../../../apis/urls";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RteEventComponent from "./TextEditor";
import RichTextEditor from "@mantine/rte";
import { DatePicker, message, Space, Spin } from "antd";
import moment from "moment";

const WorkshopMultipleUpdate = () => {

    const { wid, sid, id } = useParams();

    useEffect(() => {
        editlisting();
    },[]
    );

    const [res,setRes] = useState([]);
    const [topic,setTopic] = useState('');
    const [description, setDescription] = useState('');
    const [max_seats, setMax_seats] = useState('');
    const [presenter_name,setPresenter_name] = useState('');
    const [presenter_title,setPresenter_title] = useState('');
    const [presenter_organization,setPresenter_organization] = useState('');
    const [image, setImage] = useState('');
    const [imageUp, setImageUp] = useState('');
    const [imgLoading, setImgLoading] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [keys, setKeys] = useState('');
    const [keysImg, setKeysImg] = useState('');


    const [topicErr, setTopicErr] = useState(false)
    const [seatErr, setSeatErr] = useState(false)
    const [pnameErr, setPnameErr] = useState(false)
    const [ptitleErr, setPtitleErr] = useState(false)
    const [porgErr, setPorgErr] = useState(false)

    const [status, setStatus] = useState('');
    const [topicerror,setTopicerror] = useState(false);
    const [alertText, setAlertText]=useState("");


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/workshop/session/"+wid+"/"+sid)
        
    }


    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopListURL+'/view/multiple/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            //console.log(response.data.data.topic)
            console.log("topic",response.data.data.description.length)
            setTopic(response.data.data.topic);
            setDescription(response.data.data.description.length === 0?`&nbsp;`:response.data.data.description);
            setMax_seats(response.data.data.max_seats);
            setPresenter_name(response.data.data.presenter_name);
            setPresenter_title(response.data.data.presenter_title);
            setPresenter_organization(response.data.data.presenter_organization);
            setImage(response.data.data.image)
            setStartDate(response.data.data.start_date)
            setEndDate(response.data.data.end_date)
            setKeys(response.data.data.key)
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {


        let error = 0;

        if(topic === '')
        {
            setTopicErr(true)
            error =1;
        }else{
            setTopicErr(false)
        }

        if(max_seats === '')
        {
            setSeatErr(true)
            error =1;
        }else{
            setSeatErr(false)
        }

        if(presenter_name === '')
        {
            setPnameErr(true)
            error =1;
        }else{
            setPnameErr(false)
        }

        if(presenter_title === '')
        {
            setPtitleErr(true)
            error =1;
        }else{
            setPtitleErr(false)
        }

        if(presenter_organization === '')
        {
            setPorgErr(true)
            error =1;
        }else{
            setPorgErr(false)
        }
        

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
        
            const data = {
                topic :topic,
                description :description,
                max_seats:max_seats,
                presenter_name:presenter_name,
                presenter_title:presenter_title,
                image:imageUp?imageUp: image,
                presenter_organization:presenter_organization,
                start_date:startDate,
                end_date:endDate,
                key:keysImg?keysImg:keys
            }
            
            const instance = axios.create({

                baseURL: WorkshopListURL+'/update/multiple/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{

                message.success('Workshop updated successfully')
                

                    navigate("/workshop/session/"+wid+"/"+sid)

            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });

        }

        
    }



    const [disabled, setDisabled] = useState(false)

    const  changeHandler=(event)=>{

        setImgLoading(true)
        setDisabled(true)

        console.log("event", event.target.files[0])
		let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event.target.files[0])

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

			// console.log("respooonse", response.data)
			setImageUp(response.data.Location)
            setImgLoading(false)
            setKeysImg(response.data.Key)
            setDisabled(false)
            deleteImage();

        }).catch((error) =>{     
            console.log('error',error.message)  
        });

	}



    const  deleteImage=()=>{

		let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            key : keys,
        }

        console.log(datas)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/delete/'+keys,
            timeout: 1000000,
            body:datas,
            headers: {'authorization': token},
        });


        instance.delete('', datas).then((response) =>{

        }).catch((error) =>{     
            console.log('error',error.message)  
        });

	}



    const startDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        setStartDate(e)
      };

      const endDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        setEndDate(e)
      };




      



    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Workshop</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/workshop/session/"+wid+"/"+sid}>Workshop</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Update Workshop</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div class="card formcard medium">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label className="degreehead">Workshop Topic <span style={{color: "red"}}>*</span></label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setTopic(e.target.value)}} defaultValue={res.topic} id="topic"></input>
                                        {
                                        topicErr
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Topic</div>
                                        :null
                                        }
                                    </div>
                                    <div class="form-group">

                                        <label className="degreehead">Description</label>

                                        <RteEventComponent setdescription={setDescription} description={description} />


                                    </div>

                                    <div class="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="degreehead">Start Date<span style={{color: "red"}}>*</span></label>
                                                {startDate?
                                                <DatePicker
                                                className="workshop-date"
                                                showTime={{ format: 'hh:mm a' }}
                                                format="MM-DD-YYYY hh:mm a"
                                                defaultValue={moment( moment(startDate).format('MM-DD-YYYY hh:mm a'), "MM-DD-YYYY hh:mm a")} 
                                                style={{width:"100%"}} onChange={(e)=>{startDatePick(e)}} />:null
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <label className="degreehead">End Date<span style={{color: "red"}}>*</span></label>
                                            {endDate?
                                                <DatePicker 
                                                className="workshop-date"
                                                format="MM-DD-YYYY hh:mm a"
                                                defaultValue={moment( moment(endDate).format('MM-DD-YYYY hh:mm'), "MM-DD-YYYY hh:mm")} 
                                                style={{width:"100%"}} showTime onChange={(e)=>{endDatePick(e)}} />:null
                                            }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="degreehead">Maximum Seats<span style={{color: "red"}}>*</span></label>
                                                <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setMax_seats(e.target.value)}} defaultValue={res.max_seats} id="topic"></input>
                                                {
                                                seatErr
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Maximum Seats</div>
                                                :null
                                                }
                                            </div>

                                            <div className="col-md-6">

                                                <label className="degreehead">Presenter Name<span style={{color: "red"}}>*</span></label>
                                                <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setPresenter_name(e.target.value)}} defaultValue={res.presenter_name} id="topic"></input>
                                                {
                                                pnameErr
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Presenter Name</div>
                                                :null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="degreehead">Presenter Title <span style={{color: "red"}}>*</span></label>
                                                <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setPresenter_title(e.target.value)}} defaultValue={res.presenter_title} id="topic"></input>
                                                {
                                                ptitleErr
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Presenter Title</div>
                                                :null
                                                }
                                            </div>

                                            <div className="col-md-6">
                                                <label className="degreehead">Presenter Organization<span style={{color: "red"}}>*</span></label>
                                                <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setPresenter_organization(e.target.value)}} defaultValue={res.presenter_organization} id="topic"></input>
                                                {
                                                porgErr
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Presenter Organization</div>
                                                :null
                                                }
                                            </div>  

                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div className="row">

                                            <div className="col-md-6">
                                                <label className="degreehead">Upload Image</label>

                                                <div class="centers">
                                                    <div class="form-inputs">
                                                        <div class="previews spinner-workshop">
                                                            {!imgLoading?
                                                                <img src={imageUp?imageUp:image} style={{display:'block'}} id="file-ip-1-previews" />:
                                                                <Space style={{width:"100%"}} direction="vertical">
                                                                    <Spin className="spinner-workshop" tip="Loading" size="small">
                                                                        <div className="content" />
                                                                    </Spin>
                                                                </Space>
                                                            }
                                                        </div>
                                                        <label for="file-ip-1s">Upload Image</label>
                                                        <input type="file" id="file-ip-1s" accept="image/*"
                                                        onChange={(event)=>{changeHandler(event)}}    />
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                    <h6 style={{color:"red", fontSize:'12px', paddingTop:'10px'}}>* Required Fields</h6>
                                    
                                    <div class="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button disabled={disabled} onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                    </div>
                                    <div>
                                    {/* <button onClick={notify}>Notify !</button> */}
                                    <ToastContainer
                                        style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                        toastStyle={{backgroundColor: "#f1c40f", color: 'white', fontSize: 16}}
                                        progressStyle={{backgroundColor: 'white'}}
                                        
                                    />
                                </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default WorkshopMultipleUpdate;